import { Card } from "../components/Card";
import { PageHeader } from "../components/PageHeader";
import { leadership } from "../lib/constants";

export function Leadership() {
  return (
    <>
      <PageHeader
        eyebrow="القيادة"
        title="فريق القيادة"
        description="تظهر هذه الصفحة الأسماء والمناصب المقدمة فقط، دون إضافة مؤهلات أو صور أو سنوات خبرة غير موثقة."
      />
      <section className="py-20">
        <div className="container grid gap-4 md:grid-cols-2">
          {leadership.map((person) => (
            <Card key={person.name}>
              <div className="mb-6 grid h-16 w-16 place-items-center rounded-md bg-charcoal text-2xl font-bold text-gold">
                {person.name.replace(/^.\.\s*/, "").slice(0, 1)}
              </div>
              <h2 className="text-2xl font-bold text-charcoal">{person.name}</h2>
              <p className="mt-3 text-lg font-bold leading-8 text-ash">{person.title}</p>
            </Card>
          ))}
        </div>
      </section>
    </>
  );
}
